import script from "./PayrollReport.vue?vue&type=script&setup=true&lang=ts"
export * from "./PayrollReport.vue?vue&type=script&setup=true&lang=ts"

import "./PayrollReport.vue?vue&type=style&index=0&id=5dfd7408&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5dfd7408"]])

export default __exports__